import { useEffect } from "react";
import HomeSvg from "../../../../../assets/icons/home.svg";
import "../../../../../assets/styles/TD/TD001.css";
import BreadcrumbComponent from "../../../../../common/components/breadcrumb/BreadcrumbComponent";
import MenuWrapperComponent from "../../../../../common/components/menu-wrapper";
import HandlerImpl from "../handler/HandlerImpl";
import TodoList from "./TodoList";
import TodoListCategory from "./TodoListCategory";
import LoadingComponent from "../../../../../common/components/icons/LoadingComponent";
import { Col, Row, Spin, Tooltip } from "antd";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import EmptyData from "../../../../../assets/images/nodata-td001.svg";
import SortDescIcon from "../../../../../assets/icons/icon-sort-down-todo.svg";
import SortIncIcon from "../../../../../assets/icons/icon-sort-up-todo.svg";

const BREADCRUMB_TD001 = [
  {
    title: "タスク管理",
    url: "",
    icon: (
      <img style={{ paddingBottom: 2, paddingRight: 8 }} alt="" src={HomeSvg} />
    ),
  },
];

export default function MainUI({ handler }: { handler: HandlerImpl }) {
  const [searchParams] = useSearchParams();
  const todoCategoryList = useSelector(
    (state: RootState) => state.todoTaskWorkflow.todoCategoryList
  );
  const isLoading = useSelector((state: RootState) => state.common.loading);
  const page = searchParams.get("page") || 1;
  const categoryId = searchParams.get("categoryId");
  const sortBy = searchParams.get("sortBy") || "newest";
  const size = searchParams.get("size") || 50;

  useEffect(() => {
    if (todoCategoryList.length > 0) {
      const prams = {
        categoryId,
        page: +page,
        sortBy,
        size: +size,
      };
      handler.getTodoListByCategory(prams);
    }
  }, [page, categoryId, sortBy, size, todoCategoryList?.length]);

  return (
    <Spin indicator={LoadingComponent} spinning={handler.isLoadingList}>
      <MenuWrapperComponent chosenKey={99} openKey={7}>
        <div className="sn01-wrapper">
          <BreadcrumbComponent data={BREADCRUMB_TD001} />
          <h2 className="sn01-header">タスク管理</h2>
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <TodoListCategory
              checkCategorySelected={handler.checkCategorySelected}
              categoryIdSelected={handler.categoryIdSelected}
              todoCategoryList={handler.todoCategoryList}
              onSelectCategory={handler.onSelectCategory}
            />
            <Row justify="center" style={{ marginTop: "16px" }}>
              <Col span={12}>
                <span className="td001-todo__title">タスク一覧</span>
              </Col>
              <Col
                style={{
                  justifyContent: "end",
                  display: "inline-flex",
                  height: "min-content",
                }}
                span={12}
              >
                <Tooltip
                  placement="bottom"
                  title={sortBy === "newest" ? "新しい順" : "古い順"}
                >
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={handler.toggleSortType}
                  >
                    {sortBy === "newest" ? (
                      <img
                        alt=""
                        style={{ width: "24px" }}
                        src={SortDescIcon}
                      />
                    ) : (
                      <img alt="" style={{ width: "24px" }} src={SortIncIcon} />
                    )}
                  </div>
                </Tooltip>
              </Col>
            </Row>
            {isLoading ? (
              <></>
            ) : handler.todoTaskList.length == 0 ? (
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={EmptyData} alt="" />
              </div>
            ) : (
              <TodoList
                setPageSize={handler.setPageSize}
                setPageNumber={handler.setPageNumber}
                total={handler.pagination?.count || 0}
                page={+page}
                size={+size}
                todoTaskList={handler.todoTaskList}
                onClickTodo={handler.onClickTodo}
              />
            )}
          </div>
        </div>
      </MenuWrapperComponent>
    </Spin>
  );
}
